"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuTheme = void 0;
const styles_1 = require("@mui/material/styles");
const styles_2 = require("@mnemonic/mui5/styles");
const useMenuTheme = () => {
    // Get the theme that is defined higher than the menu in the render tree.
    const parentTheme = (0, styles_1.useTheme)();
    // The menu is always dark.
    // NFCert don't have a dedicated dark theme. Using Mnemonic dark theme.
    const darkTheme = (0, styles_2.createMnemonicDarkTheme)();
    const menuTheme = (0, styles_1.createTheme)(darkTheme, {
        palette: {
            // The dark theme uses a #3DB6B9 (cyan/blue) as primary. In the menu we want to use white.
            primary: { main: parentTheme.palette.common.white },
            // Set the orange/secondary color in the menu to match the orange/secondary color in the page.
            secondary: parentTheme.palette.secondary,
        },
    });
    return { menuTheme, parentTheme };
};
exports.useMenuTheme = useMenuTheme;
